import { Serializable } from "../utilities/Serializable";

export class TaxRate extends Serializable {
    uuid: string;
    description: string;
    percentageAmount: number;
    department: number;
}


// WEBPACK FOOTER //
// ./src/app/models/TaxRate.ts